import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import PlatformSettingsAPI, { type PlatformSettings } from '@/api/platformSettings.api';

const QUERY_KEY = ['platformSettings'] as const;

/** Load platform settings from server. Falls back to defaults on error. */
export function usePlatformSettings() {
  return useQuery({
    queryKey: QUERY_KEY,
    queryFn: PlatformSettingsAPI.get,
    staleTime: 5 * 60_000,  // cache 5 min — settings change rarely
    retry: false,
  });
}

/** Persist updated settings to server. */
export function useSavePlatformSettings() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (settings: PlatformSettings) => PlatformSettingsAPI.save(settings),
    onSuccess: (saved) => {
      qc.setQueryData(QUERY_KEY, saved);
    },
  });
}
